import React, { memo } from 'react'
import { RadioGroup } from 'transfix-ui/components/RadioGroup'
import { DELIVERY_TIME_OPTIONS } from 'apps/marketplace/utils/constants/rates'
import { ChangeRateData } from 'apps/marketplace/utils/helpers/useCarrier'

interface IDeliveryPreferenceProps {
  deliveryTimePreference: string
  onChange: (arg: Partial<ChangeRateData>) => void
}

export const DeliveryPreference = memo<IDeliveryPreferenceProps>(
  ({ deliveryTimePreference, onChange }) => {
    const onChangeDeliveryTimePreference = ({
      target: { value },
    }: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ deliveryTimePreference: value })
    }

    return (
      <>
        <h3>Delivery Settings</h3>
        <div className='row'>
          <div className='col-md-9' data-test='delivery-time-preference'>
            <RadioGroup
              label='Shipments must deliver:'
              name='delivery-time-preference'
              onOptionChange={onChangeDeliveryTimePreference}
              checked={deliveryTimePreference}
              options={DELIVERY_TIME_OPTIONS}
            />
          </div>
        </div>
      </>
    )
  }
)
